import * as yup from "yup";

export const INTERVENTION_AND_PLAN_CHARACTER_LIMIT_ERROR = "Cannot enter more than 4000 characters";
export const INTERVENTION_AND_PLAN_CHARACTER_LIMIT = 4000;
const GOAL_SCHEMA = yup.object().shape({
  interventions_and_plans: yup
    .string()
    .max(INTERVENTION_AND_PLAN_CHARACTER_LIMIT, INTERVENTION_AND_PLAN_CHARACTER_LIMIT_ERROR),
});

export const INTERVENTION_AND_PLAN_SCHEMA = yup.object().shape({
  goal_1: GOAL_SCHEMA,
  goal_2: GOAL_SCHEMA,
  goal_3: GOAL_SCHEMA,
});
